import { render, staticRenderFns } from "./MatchMaking.vue?vue&type=template&id=bd87b274&scoped=true&"
import script from "./MatchMaking.vue?vue&type=script&lang=ts&"
export * from "./MatchMaking.vue?vue&type=script&lang=ts&"
import style0 from "./MatchMaking.vue?vue&type=style&index=0&id=bd87b274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd87b274",
  null
  
)

export default component.exports